import * as types from '../mutation-types';
import store from 'utils/store';
import loginApi from 'api/login';
const userStore = {
  state: {
    token: store.get('token'),
    userInfo: store.get('userInfo')
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo
  },
  mutations: {
    [types.SET_TOKEN](state, data) {
      state.token = data;
      if (data) {
        store.set('token', data);
        store.set('tokenTime', new Date().getTime());
      } else {
        store.remove('token');
        store.remove('tokenTime');
      }
    },
    [types.SET_USER_INFO](state, data) {
      state.userInfo = data;
      if (data) {
        store.set('userInfo', data);
      } else {
        store.remove('userInfo');
      }
    }
  },
  actions: {
    // 登录，并存token
    login({ commit }, params) {
      return new Promise((resolve, reject) => {
        loginApi.login(params).then(
          response => {
            commit(types.SET_TOKEN, response.data.data);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    // 根据token获取用户信息
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        loginApi.getUserInfo().then(
          response => {
            // console.log(response);
            if (response.data.data.appList.length === 0) {
              return resolve(response);
            }
            commit(types.SET_USER_INFO, response.data.data);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    // 退出登录
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        loginApi.logout().then(
          response => {
            commit(types.SET_TOKEN, null);
            commit(types.SET_USER_INFO, null);
            store.remove('token');
            store.remove('userInfo');
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    }
  }
};

export default userStore;
